import React, {useState, useEffect} from 'react';
import { Button,Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

import UsedBomDatatable from './UsedBomDatatable';
import UsedBomModal from './UsedBomModal';


const UsedBomModalWithDatatable = (props) => {
   
    const [t] = useTranslation();
    const [show, setShow] = useState(false);  
    const [showUserBomModal, setShowUserBomModal] = useState(false);  
              
    const [recordId, setRecordId ] = useState();    
    const [entityId, setEntityId ] = useState(null);    

    const [workOrderId, setWorkOrderId ] = useState(null);    
    const [operationId, setOperationId ] = useState(null);    
    const [bomId, setBomId ] = useState(null);   
    const [checkTime, setCheckTime ] = useState(null);   
  

    const handleCallback = (id) => {
          if(props.edit){
            setRecordId(id);
            setShowUserBomModal(show); 
          }
    };
     
    const hideModal = () => {
      setShow(false);         
      props.parentCallback(false,'');
    };

    const modalCallback = (show) => {
      setShowUserBomModal(show);
      setCheckTime(Date.now());
    }

    const handleOpenUsedBomModal = (id) => {
      setShowUserBomModal(true);
    }

   
    useEffect(() => {
        setShow(props.modal);
    }, [props.modal])

    useEffect(() => {
      setWorkOrderId(props.workOrderId);
  }, [props.workOrderId])

    useEffect(() => {
      setOperationId(props.operationId);
  }, [props.operationId])

    useEffect(() => {
      setBomId(props.bomId);
  }, [props.bomId])


    return (
 
 
      <>         
                <Modal
                  show={show}
                  onHide={hideModal}
                  container={this}
                  aria-labelledby="contained-modal-title"
                //  centered
                  size="lg"                       //xl                 
                >
                    
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">{t('workOrder.label.bomAtOperation')}</Modal.Title>
                  </Modal.Header>
                    <Modal.Body>

                      <UsedBomDatatable            
                          parentCallback={handleCallback}                                                  
                          operationId={operationId}   
                          modalShow={show}  
                          style={{maxHeight: '500px', overflowY: 'auto'}}     
                          checkTime={checkTime}             
                        />
                        <UsedBomModal 
                          modal={showUserBomModal}
                          parentCallback={modalCallback}
                          selectedRecord={recordId}
                          workOrderId={workOrderId}                          
                          operationId={operationId}                          
                          bomId={bomId}     
                        />
                        <Button                          
                          bsStyle="primary"
                        //  bsSize="large"
                          style={props.edit ? {} : { display: 'none' }}
                          className="ml-3 mt-3"
                          onClick={() => handleOpenUsedBomModal('')} //current => !current
                        >
                          <i class="fas fa-plus"></i>
                        </Button>       
                          
                    </Modal.Body>                   
                                        
                  </Modal>   
      </>
    );
};

 
 export default UsedBomModalWithDatatable;


 